// extracted by mini-css-extract-plugin
export var banner = "_o3-0";
export var settingRow = "_o3-2";
export var titleIcon = "_o3-1";